import { useQuery } from "@tanstack/react-query";
import { SplitContentContentGroupConfig } from "../splitContentTypes";
import { LoadingSmall } from "@/components/LoadingSmall";
import { DSPlayer } from "@/components/ds/player/DSPlayer";
import { PlaylistItemDTO, PlaylistResponseItem } from "@/components/ds/lib/types";
import { getDsList } from "@/components/ds/lib/dsApi";
import { useMemo } from "react";
import { isSplitContentGroup } from "@/components/ds/player/DSPlayerUtils";

interface Props {
  config: SplitContentContentGroupConfig;
}

const REFRESH_INTERVAL_MS = 1000 * 60 * 3; // 3 minutes

export const SplitContentConfigRendererContentGroup: React.FC<Props> = ({ config }) => {
  const { contentGroupGuid } = config;

  const { data: contentGroupData, isLoading: isContentGroupLoading } = useQuery({
    queryKey: ["getContentGroupMembers", contentGroupGuid],
    queryFn: () =>
      getDsList({
        contentGroupId: contentGroupGuid,
      }),
    refetchInterval: REFRESH_INTERVAL_MS,
  });

  const contentGroupMembers = contentGroupData?.data || [];

  const playlist: PlaylistItemDTO[] = useMemo(() => {
    if (isSplitContentGroup(contentGroupMembers)) {
      return [];
    }
    // TODO this component is not used now, maybe delete in future completely
    return (contentGroupMembers as PlaylistResponseItem[]).map((item) => ({
      id: item.id,
      // @ts-ignore
      intId: item.contentintId,
      type: item.type.startsWith("image/") ? "Image" : "Video",
      src: item.name,
      duration: item.duration,
      isActive: item.isActive,
    }));
  }, [contentGroupMembers]);

  if (isContentGroupLoading) {
    return <LoadingSmall />;
  }

  if (!contentGroupData || !contentGroupMembers) {
    return <div>Content group does not exist anymore?</div>;
  }

  return (
    <div className="relative overflow-hidden">
      <DSPlayer list={playlist} isFullScreen={false} debug={false} />
    </div>
  );
};
